import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PublicShell } from "@/components/layouts/AppShell";

export const Route = createFileRoute("/static/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PublicShell>
      <Outlet />
    </PublicShell>
  );
}
